/* eslint-disable max-len */
import React, {ReactElement} from "react";

import styles from "./spinner.module.scss";

const Spinner = (): ReactElement => <div className={styles.spinner}/>;

export {Spinner};
